//imports
import { result } from "lodash";
import {
    CONFIRM_USER_REQUEST,
    CONFIRM_USER_RESULT,
    CONFIRM_USER_VERIFICATE_CODE_REQUEST,
    CONFIRM_USER_VERIFICATE_CODE_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

//initial values
const INIT_STATE = {
    loading: false,
    error: null,
    resultVerifyUser: null,
    resultVerifyCode: null,
};

//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case CONFIRM_USER_REQUEST:
            return { ...state, loading: true, error: null };

        case CONFIRM_USER_RESULT:
            return { ...state, loading: false, resultVerifyUser: action.payload.result, error: action.payload.error };
        case CONFIRM_USER_VERIFICATE_CODE_REQUEST:
            return { ...state, loading: true, error: null };
        case CONFIRM_USER_VERIFICATE_CODE_RESULT:
            return { ...state, loading: false, resultVerifyCode: action.payload, error: action.payload.error };
        
            //clear redux
        case CLEAR_REDUX:
            return ["", "CONFIRM_USER"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};